import { Block } from './Block'

import { getSrc } from "gatsby-plugin-image"

/**
 * Works with the core/gallery WordPress block.
 */
export class CoreGallery extends Block {
    constructor(block) {
        super(block)
        this.setImageElements()
        this.setCaptions()
        this.getImgSources()
    }

    /**
     * Retrieves all <figure> elements with the class 'wp-block-image'
     * from the root element.
     */
    setImageElements() {
        this.imageElements = this.getElements(this.rootElement, 'figure', {
            className: { value: 'wp-block-image', match: 'includes' },
        })
    }

    /**
     * Loops through each <figure class='wp-block-image'> element and
     * creates an image object.
     */
    setImages() {
        this.images = this.imageElements.map(element => {
            let image = this.removeDuplicateObjectsByProperty(
                this.getElements(element, 'img')
                    .map(image => ({ ...image.props }))
                    .filter(img => img?.src?.startsWith('/_gatsby/image/')),
                'src',
            )

            let caption = this.getElements(element, 'figcaption')
            return { ...image[0], caption: caption[0]?.props?.children }
        })
    }

    /*Gatsby 5 updates for srcset */
    getImgSources() {
        if(!this.block?.innerBlocks){ 
            this.images = []
            return 
        }
        this.images = this.block.innerBlocks.map((block, index) => {
            return {src:getSrc(block?.mediaItem?.node?.localFile), caption: this.captions[index]}
        })

        //let caption = this.getElements(element, 'figcaption')
        //return { ...image[0], caption: caption[0]?.props?.children }
    }

    setCaptions() {
        this.captions = this.imageElements.map(element => {

            let caption = this.getElements(element, 'figcaption')
            return caption[0]?.props?.children 
        })
    }
}

/**
 * core/gallery block structure from WordPress
 *
<figure class="wp-block-gallery">
	<figure class="wp-block-image">
		<span class="wp-image-[imageID] inline-gatsby-image-wrapper gatsby-image-wrapper">
			<span></span>
			<img />
			<picture>
				<source></source>
				<img />
			</picture>
			<noscript>
				<picture>
					<source></source>
					<img />
				</picture>
			</noscript>
			<figcaption></figcaption>
		</span>
	</figure>
</figure>
 */
